<template>
    <div>
        <v-card elevation="0" color="#FFF0DF" width="100%" max-height="600px" class="overflow-auto">
            <v-card-title>
                Upcoming Due dates
            </v-card-title>
            <v-card-text v-if="!loading">
                <v-simple-table style="width: 100%; border-collapse: collapse;" dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th rowspan="2">Title</th>
                                <th rowspan="2">Discipline</th>
                                <th rowspan="2">Type</th>
                                <th rowspan="2" colspan="2">Posting Due</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.title">
                                <td>{{ item.title }}</td>
                                <td>{{ item.discipline }}</td>
                                <td>{{ item.type }}</td>
                                <td>{{ item.due }} </td>
                                <td style="text-align: center;"><span v-if="item.daysleft != 0"><b>{{ item.daysleft }}</b></span><span v-else><b>Due</b></span></td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-text v-else>
                <v-progress-linear
                    color="#FCB5AC"
                    indeterminate
                    rounded
                    v-if="calling"
                ></v-progress-linear>
                <div v-else>
                    {{ text }}
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            items: [],
            loading: true,
            calling: true,
            text: ""
        }
    },
    methods: {
        loadPostings(){
            const that = this;

            that.loading = true;
            that.calling = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=postingsget';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.loading = true;
                        that.calling = false;
                        that.text = "Calling Posting Issue: "+resultData.message;
                    }else {
                        resultData.data.forEach(element => {
                            var daysleft = that.calculateRemainingDays(element["endDate"]);
                            if(daysleft <= 5){
                                that.items.push({
                                    "title": element["title"],
                                    "discipline": element["discipline"],
                                    "type": element["type"],
                                    "due": element["endDate"],
                                    "daysleft": daysleft
                                });
                            }
                        });

                        that.items.sort((a,b) => a.daysleft - b.daysleft);

                        if(that.items.length > 0){
                            that.loading = false;
                        }else {
                            that.loading = true;
                            that.calling = false;
                            that.text = "No Posting due in 5 days."
                        }
                    }
                })
                .catch(function(){
                    that.loading = true;
                    that.calling = false;
                    that.text = "No posting";
                })
            //End of API calling
        },
        calculateRemainingDays(date){
            const MSPERDAY = 1000 * 60 * 60 * 24;
            let today = new Date();
            let due = new Date(date);
            let todayutc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
            let dateutc = Date.UTC(due.getFullYear(), due.getMonth(), due.getDate());

            return Math.floor((dateutc - todayutc) / MSPERDAY)+1;
        }
    },
    created(){
        const that = this;
        that.loadPostings();
    }
}
</script>